"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMeasurement = function (measurement) {
    return measurement ? measurement.value + "|" + measurement.unit : undefined;
};
